import { styled } from '@mui/material/styles';

type StyledAgentMetricProps = {
  flexDirection: 'column' | 'column-reverse';
  fontSize: '1.5rem' | '2.5rem';
  alignItems: 'flex-start' | 'center' | 'flex-end';
  isRefreshing: boolean;
};

const StyledAgentMetric = styled('div')<StyledAgentMetricProps>`
  display: flex;
  flex-direction: ${({ flexDirection }) => flexDirection || 'column'};
  align-items: ${({ alignItems }) => alignItems || 'flex-start'};
  justify-content: space-between;
  min-height: 112px;
  padding: 0.95rem 1rem;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 3px 12px rgba(15, 23, 42, 0.04);
  position: relative;
  overflow: hidden;

  ${({ isRefreshing }) =>
    isRefreshing &&
    `
      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: -140%;
        width: 120%;
        height: 100%;
        background: linear-gradient(
          100deg,
          rgba(255, 255, 255, 0) 20%,
          rgba(255, 255, 255, 0.55) 50%,
          rgba(255, 255, 255, 0) 80%
        );
        animation: metricShimmer 1.15s ease-in-out infinite;
      }
    `}

  @keyframes metricShimmer {
    0% {
      left: -140%;
    }
    100% {
      left: 140%;
    }
  }

  & * {
    margin: 0;
    padding: 0;
  }

  & h3 {
    color: #1673d3;
    font-size: ${({ fontSize }) => fontSize || '1.5rem'};
    font-weight: 700;
    line-height: 1.2;
  }

  & p {
    font-size: 0.8rem;
    font-weight: 600;
    color: #64748b;
    letter-spacing: 0.01em;
  }
`;

export default StyledAgentMetric;
